import { Option } from '../../types';

export const SDK_INTEROPERABILITY_WORKCELL_ID =
  'SDK_INTEROPERABILITY_WORKCELL_ID';

export const selectedWorkcellIds = [
  'az',
  'azProd',
  'titan',
  'ucbProd',
  'slas25',
  'bigKahuna',
  'lavenderNGS',
  'usDemo1bench',
  SDK_INTEROPERABILITY_WORKCELL_ID,
] as const;

export type SelectedWorkcellId = (typeof selectedWorkcellIds)[number];

const workcellIdToNameMap = {
  az: 'Aloe',
  azProd: 'Aloe Prod',
  titan: 'Titan',
  ucbProd: 'Ulex',
  slas25: 'slas25',
  bigKahuna: 'Kahuna',
  lavenderNGS: 'Lavender',
  usDemo1bench: 'US Demo 1-Bench',
  SDK_INTEROPERABILITY_WORKCELL_ID: 'Defined by SDK workflow',
} as const satisfies Record<SelectedWorkcellId, string>;

export type SelectedWorkcellName =
  (typeof workcellIdToNameMap)[SelectedWorkcellId];

export const HARDCODED_WORKCELL_OPTIONS: Option<
  SelectedWorkcellId,
  SelectedWorkcellName
>[] = Object.entries(workcellIdToNameMap).map(([id, name]) => ({
  id: id as SelectedWorkcellId,
  name,
}));

export const DEFAULT_HARDCODED_WORKCELL_ID: SelectedWorkcellId = 'titan';

export const isSelectedWorkcellId = (
  workcellId: unknown
): workcellId is SelectedWorkcellId =>
  typeof workcellId === 'string' &&
  selectedWorkcellIds.includes(workcellId as any);
